import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateLostMutationRequest, CreateLostMutationResponse } from "../../types/CreateLost";

/**
     * @link /api/credit-flow-backend/private/v1/funding/do_create-lost
     */
export async function createLost (data: CreateLostMutationRequest, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CreateLostMutationResponse>["data"]> {
    const { data: resData } = await client<CreateLostMutationResponse, CreateLostMutationRequest>({
        method: "post",
        url: `/api/credit-flow-backend/private/v1/funding/do_create-lost`,
        data,
        ...options
    });
    
    return resData;
};